<template>
  <div class="data-select" :class="isValid?'valid':'invalid'">
    <label :for="id">{{ label }}</label>
    <slot/>
    <select type="text"
            class="custom-select"
            :id="id"
            :value="value || ''"
            :required="required"
            @change="onInput"
    >
      <option v-if="showDefaultOption" value="" selected="selected">{{ $t('placeholder_choose') }}</option>
      <option v-for="opt in options"
              v-if="maxValue === undefined || parseInt(opt) < maxValue"
              :value="opt"
              :selected="opt === value">{{ $t(opt.toLocaleString()) }}&nbsp;{{ $t(unit) }}
      </option>
    </select>
  </div>
</template>
<script>
import uuid from 'uuid'

export default {
  name: "DataSelect",
  props: {
    label: String,
    maxValue: {
      type: Number,
    },
    value: String | Number,
    options: Array,
    unit: String,
    required: {type: Boolean, default: false}
  },
  data() {
    return {
      id: 'id_' + uuid.v1(),
      isValid: true
    }
  },
  computed: {
    showDefaultOption() {
      return this.options.indexOf(this.value) === -1
    }
  },
  methods: {
    emitInputEvent(event) {
      console.log('emit input: ', event.target.value)
      console.warn('!!!!emit input: ', event.target.value)
      this.$emit('input', event.target.value)
    },
    onInput(e) {
      this.$emit('input', e.target.value);
      this.isValid = e.target.validity.valid;
    }
  }
}
</script>
